import { NamedEntity } from 'types'
import { getArtistUrl } from 'utils/urls'

export function mapArtistHref<T extends Partial<NamedEntity>>(
  artists: T[] | undefined
): (T & { href: string })[] | undefined {
  return artists?.map(a => ({
    ...a,
    href: getArtistUrl(a?.name || '', a.id || 0),
  }))
}
